<template>
  <div
    style="position: absolute; z-index: 20; right: 10px; top: 84px"
    v-if="$store.state.popupMantenimientoVisualizations === 1"
  >
    <div
      :class="{
        'pointer-events-auto':
          $store.state.popupMantenimientoVisualizations === 1
      }"
      ref="modalContent"
    >
      <transition name="modal-animate" appear>
        <div
          v-if="$store.state.popupMantenimientoVisualizations === 1"
          class="zt-modal rounded bg-white w-full shadow-lg relative lg:w-auto m-4"
          :style="{ width: maxWidth }"
        >
          <div
            v-if="showButtonClose"
            class="zt-modal-button-close p-1 flex items-center justify-center absolute cursor-pointer rounded-full popup-legajo-close hover:text-zt-primary-200"
            data-vs-button="modal-button-close-mantenimiento"
            @click.stop="
              $emit('close')
              $store.dispatch('setPopupMantenimientoVisualizations', 2)
              $store.dispatch('setMsgOutage', '')
            "
          >
            <zt-icon class="" name="times" />
          </div>

          <div class="flex items-start p-4 rounded-t">
            <h4 class="text-zt-dark-400 font-bold">
              {{ $t('message.uploadImageComponent.maintenance.title') }}
            </h4>
          </div>

          <div class="zt-modal-body">
            <div class="px-4" v-html="$sanitize($store.state.msgOutage)"></div>
          </div>
          <div class="flex justify-start items-center p-4">
            <zt-button
              outlined
              color="dark"
              data-vs-button="modal-button-close-down-mantenimiento-"
              @click="
                $emit('close')
                $store.dispatch('setPopupMantenimientoVisualizations', 2)
                $store.dispatch('setMsgOutage', '')
              "
              >{{
                $t('message.uploadImageComponent.maintenance.understood')
              }}</zt-button
            >
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import User from '../../apiClient/User'

export default {
  name: 'PopupMantenimiento',
  props: {
    title: {
      type: String
    },
    showButtonClose: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },
  data() {
    return {
      user: null
    }
  },
  created() {
    this.user = new User()
    this.getMsgMaintenance()
  },
  methods: {
    async getMsgMaintenance() {
      if (this.$store.state.popupMantenimientoVisualizations === 0) {
        this.user
          .getMsgMaintenance()
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('setPopupMantenimientoVisualizations', 1)
              this.$store.dispatch('setMsgOutage', response.data.data)
            }
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style scoped lang="css">
::v-deep .zt-button-outline-dark {
  color: #4f41a3 !important;
  border-width: 1px;
  border-style: solid;
  border-color: #4f41a3;
  background-color: #fff;
}
.top-popup-legajo {
  top: 6.5rem;
  z-index: 20;
}
.popup-legajo-close {
  right: 10px;
  top: 10px;
  font-size: 10px;
}
</style>
